<script setup>
// Banner promocional: gradiente da marca + silhueta de hangar/aeronave.
</script>

<template>
  <section class="relative overflow-hidden rounded-card bg-up-navy shadow-card">
    <svg viewBox="0 0 400 240" class="absolute inset-0 h-full w-full" preserveAspectRatio="xMidYMax slice" aria-hidden="true">
      <defs>
        <linearGradient id="promo-sky" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stop-color="#12395f" />
          <stop offset="100%" stop-color="#0F2A4A" />
        </linearGradient>
      </defs>
      <rect width="400" height="240" fill="url(#promo-sky)" />
      <!-- Hangar ao fundo -->
      <path d="M40 150q160-70 320 0v70H40z" fill="#1B3D66" opacity=".7" />
      <path d="M150 170h100v50H150z" fill="#0F2A4A" opacity=".8" />
      <!-- Pista -->
      <rect y="206" width="400" height="34" fill="#0B2039" />
      <!-- Aeronave em silhueta -->
      <g fill="#E7EDF4" opacity=".92">
        <path d="M120 196h150l40-10-40-10h-40l-30-22h-14l14 22h-40l-14-12h-10l8 12-24 4z" />
        <path d="M168 196l-12 14h8l16-14zM246 196l10 14h9l-9-14z" />
      </g>
    </svg>

    <div class="relative px-6 py-10 sm:px-8 sm:py-14">
      <p class="max-w-xs text-lg font-semibold leading-snug tracking-wide text-white sm:text-xl">
        MAIS QUE MANUTENÇÃO<br />É O SEU PRÓXIMO DESTINO
      </p>
    </div>
  </section>
</template>
